// Angular
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

// Afidium
import { DescriptionModule } from 'libraries/hotel/components/description/description.module';
import { PropertyDescriptionComponent } from './property-description.component';
import { MatDialogModule } from '@angular/material/dialog';
import { HotelResumeModule } from 'libraries/hotel/components/hotel-resume/hotel-resume.module';
import { CardModule } from 'libraries/ui_card/card.module';
import { QuotationServiceModule } from 'libraries/hotel/services/quotation/quotation.module';
import { InformationsModule } from 'libraries/hotel/components/informations/informations.module';
import { MenuDetailsModule } from 'libraries/hotel/components/menu-details/menu-details.module';
import { BtnModule } from 'libraries/ui_button/btn.module';
import { MapModule } from 'libraries/map/map.module';
import { HotelInformationsModalModule } from 'libraries/hotel/components/hotel-informations-modal/hotel-informations-modal.module';
import { NotificationModule } from 'libraries/component/notification/notification.module';
import {FontAwesomeModule} from "@fortawesome/angular-fontawesome";

@NgModule({
    declarations: [
        PropertyDescriptionComponent,
    ],
    imports: [
        CommonModule,
        DescriptionModule,
        MatDialogModule,
        HotelResumeModule,
        CardModule,
        QuotationServiceModule,
        InformationsModule,
        MapModule,
        MenuDetailsModule,
        BtnModule,
        HotelInformationsModalModule,
        NotificationModule,
        FontAwesomeModule,
    ],
    exports: [
        PropertyDescriptionComponent,
    ],
    entryComponents: [
        PropertyDescriptionComponent,
    ],
})
export class PropertyDescriptionModule {}
